import { useQuery, type QueryClient } from '@tanstack/react-query';

import { deepClone } from '#packages/data-collection/utils/object';

import { APP_SETTINGS_QUERY_KEY } from '#apps/client-web/features/settings/types/react-query';
import { type AppSettingsService } from '#apps/client-web/features/settings/services/app-settings';
import { AppSettingsSchema } from '#apps/client-web/features/settings/models/app-settings';

export const useLoadAppSettingsQuery = ({
  appSettingsService,
  queryClient,
}: {
  appSettingsService: AppSettingsService;
  queryClient: QueryClient;
}) => {
  return useQuery(
    {
      queryKey: [APP_SETTINGS_QUERY_KEY],
      queryFn: async () =>
        (await appSettingsService.load()) ??
        deepClone(AppSettingsSchema.decode({})),
    },
    queryClient,
  );
};
